import { createAction } from 'redux-actions';

export const setAudio = createAction('SET_AUDIO');
export const resetAudio = createAction('RESET_AUDIO');

export default {
  setAudio,
  resetAudio,
};
